import { Injectable } from '@angular/core';
import { DocumentNode } from 'graphql';
import gql from 'graphql-tag';

@Injectable({
  providedIn: 'root'
})
export class Mutations {
  acceptEquipment(): DocumentNode {
    return gql`
      mutation acceptEquipment($id: ID!, $reason: String) {
        acceptEquipment (id: $id, reason: $reason) {
          status
          notes
          resolvedAt
          resolvedBy {
            id
            name
            email
          }
        }
      }
    `;
  }

  refuseEquipment(): DocumentNode {
    return gql`
      mutation refuseEquipment ($id: ID!, $reason: String!) {
        refuseEquipment (id: $id, reason: $reason) {
          status
          notes
          resolvedAt
          resolvedBy {
            id
            name
            email
          }
        }
      }
    `;
  }
}
